module.exports = __webpack_public_path__ + "img/trum-pool.ae983542.webp";